// extracted by mini-css-extract-plugin
module.exports = {"headerContent":"gift-content-skeleton_headerContent__9d_wx","contentContainer":"gift-content-skeleton_contentContainer__iLcr0"};